import type { FaireProductEntity } from "../../entity_types/product";

export const p_6d1sb63u: FaireProductEntity = {
  token: "p_6d1sb63u",
  type: "product",
  name: "Nice Jewish Girl Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/res/hszgttpjt/image/upload/56a5c83dbc74a2896a1ce51b4a094c9b947dbac7abf4b0c44957b95c9e5a087f/1535410138.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/983eee9b94a20f97f468ad800d6756b0ca73de6b3a893055d82a1f4f491ffd30.jpeg",
    "https://cdn.faire.com/fastly/c01fc725da1d16e8ed5716b9dd26107c9199c805404d55046c3f58a7d122a26f.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/071e5f49682b76c0d2d81921348d629b1aa0c09a23e0a92627483ab2071ea1f0.jpeg",
    "https://cdn.faire.com/fastly/33a27cb0382252c08057265ec2964767827f1ae271218f0cd7fdf79fe358b8a5.jpeg",
    "https://cdn.faire.com/fastly/2e29b4adb88858fb5632174d098fb7973c4737e30943b6e117e25fb2ce3bfddd.jpeg",
    "https://cdn.faire.com/fastly/63e1680079a1a36e88f8df8dda73725127f36d47fd4bb4e73ee397b7cad9ca8e.jpeg",
    "https://cdn.faire.com/fastly/71dd166c92d42039d713968990f49d379e3cbec406d27d3d0582a345e1796c4e.jpeg"
  ],
  priceDollars: 6.75,
  description: "A nice pair of socks for a Nice Jewish Girl. NOT for your goy friends.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:09.871Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
